import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, FormCheck, FormGroup, Modal, Row } from 'react-bootstrap';
import { calculaDiffDatas, dateDbToBr, float2moeda } from '../../utils/Funcoes';
import { z } from 'zod';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { tiposServicosUtils } from '../../utils/tiposServicosUtils';
import { statusAgendamentosUtils } from '../../utils/statusAgendamentosUtils'
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { ServicosService } from '../../services/api/Servicos/ServicosService';
import { ClienteService } from '../../services/api/Clientes/ClienteService'
import { AgendamentosService } from '../../services/api/Agendamentos/AgendamentosService';
import './agenda.css'
import { DayPilot } from '@daypilot/daypilot-lite-react';
import { NumericFormat } from 'react-number-format';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PermissoesComponent from '../../components/PermissaoComponent';

const AgendaCadModal = ({ children, show, args, handleClose, handleConfirm, refreshAgendamentos, filtrosAgenda, dadosProfissional, listPermissoes }) => {



    const [idAgendamento, setIdAgendamento] = useState(null)
    const [agendamento, setAgendamento] = useState(null)

    const [selectedCliente, setSelectedCliente] = useState([])
    const [optionsClientes, setOptionsClientes] = useState([])
    const [optionsAnimais, setOptionsAnimais] = useState([])

    const [selectedservico, setSelectedServico] = useState([])
    const [optionsServicos, setOptionsServicos] = useState([])
    const [tipoServicosAtend, setTipoServicosAtend] = useState([])

    const [showTermino, setShowTermino] = useState(false)
    const [valorTotal, setValorTotal] = useState(0)
    const [naoAtende, setNaoAtende] = useState('')
    const [txtDiaria, setTxtDiaria] = useState('');

    const scheme = z.object({
        animaisId: z.coerce.string(),
        clientesId: z.coerce.string().nullable(),
        observacoes: z.string().nullable(),
        dataInicio: z.coerce.string(),
        horaInicio: z.coerce.string(),
        dataTermino: z.coerce.string().nullable(),
        horaTermino: z.coerce.string().nullable(),
        duracao: z.optional(z.coerce.string()),
        servicosId: z.optional(z.number()),
        servicosQnt: z.optional(z.coerce.string()),
        servicosAgendaItemId: z.optional(z.coerce.string()),
        servicosValor: z.optional(z.coerce.string()),
        tiposServicosId: z.optional(z.string()),
        status: z.optional(z.coerce.string()),
        profissionaisId: z.optional(z.coerce.string()),
        tipoAgendamentoId: z.optional(z.coerce.string())
    }).refine((data) => { return !(data.clientesId == 'undefined' && data.tipoAgendamentoId == 1) }, {
        message: "Informe o paciente",
        path: ["clientesId"], // path of error
    }).refine((data) => { return !((data.animaisId == 'undefined' || data.animaisId == '') && data.tipoAgendamentoId == 1) }, {
        message: "Informe o animal",
        path: ["animaisId"], // path of error
    })


    const { register, handleSubmit, setValue, getValues, reset, watch, formState: { errors }, control } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: agendamento
    });

    const [exibeTipoAg, setExibeTipoAg] = useState(1)

    const watchTipoAgendamento = watch('tipoAgendamentoId')
    const watchQntServicos = watch('servicosQnt')
    const watchDtInicio = watch('dataInicio')
    const watchDtTermino = watch('dataTermino')
    const watchservicosValor = watch('servicosValor')

    const calculaDiasPernoite = () => {
        let dtIni = new Date(getValues('dataInicio'));
        let dtFim = new Date(getValues('dataTermino'));
        let days = calculaDiffDatas(dtIni, dtFim);
        setTxtDiaria('Total de ' + days + ' diárias')
        return days;
    }

    useEffect(() => {

        //  console.log(args)
        reset()
        const fetchAgendamento = async (id) => {

            const dados = await AgendamentosService.getById(id);
            let servicoId = dados.data?.agendamentoItens[0]?.servicosId
            let servicoValor = dados.data?.agendamentoItens[0]?.valorServico
            //console.log(dados)

            let dateInicio = dados.data.inicio.split(' ')
            let dataTermino = (dados.data?.termino != null) ? dados.data.termino.split(' ') : null;
            setAgendamento({
                clientesId: dados.data?.clientes?.id,
                animaisId: dados.data?.animais?.id.toString(),
                dataInicio: dateInicio[0],
                horaInicio: dateInicio[1].substring(0, 5),
                servicosId: dados.data?.agendamentoItens[0]?.servicosId,
                servicosQnt: dados.data?.agendamentoItens[0]?.qnt,
                servicosValor: servicoValor,
                servicosAgendaItemId: dados.data?.agendamentoItens[0]?.id,
                dataTermino: (dataTermino != null) ? dataTermino[0] : null,
                horaTermino: (dataTermino != null) ? dataTermino[1] : null,
                status: dados.data.status,
                profissionaisId: dados.data?.profissionaisId,
                observacoes: dados.data?.observacoes,
                tiposServicosId: dados.data?.tiposServicosId

            })
            setExibeTipoAg(dados.data?.tipoAgendamentoId)

            console.log(dados.data)
            setTipoServicosAtend([dados.data?.tiposServicosId])


            if (dataTermino != null) {
                setShowTermino(true)
            }

            setSelectedCliente([dados.data?.clientes])
            setOptionsAnimais(dados.data?.animaisClientes)

            if (servicoId != null) {
                const servico = await ServicosService.getById(servicoId)
                setOptionsServicos([servico.data])
                setSelectedServico([servico.data])
                if (servico?.data?.precoVariavel == 1) {
                    setValue('servicosValor', (servicoValor != null) ? servicoValor : servico?.data?.valor)
                }
            }

        }




        //tipos de serviço  do profissionail
        /* if (dadosProfissional?.profissional_tipos_servicos.length > 0) {
 
             let idsTpServicos = [];
             dadosProfissional?.profissional_tipos_servicos.map((item) => {
                 idsTpServicos.push(item.tiposServicosId)
             })
             setTipoServicosAtend(idsTpServicos)
         }*/


        if ((listPermissoes?.cadastrar && args?.id == null)
            || (listPermissoes?.editar && args?.id != null)
        ) {
            //console.log(filtrosAgenda)
            if (args != null) {
                if (args?.id != undefined) {
                    setIdAgendamento(args.id)
                    fetchAgendamento(args.id)
                } else {
                    setIdAgendamento(null)

                    let dataHora = args.start.toString().split('T')
                    setValue('dataInicio', (dataHora[0]))
                    setValue('horaInicio', dataHora[1].substring(0, 5))
                    setValue('dataTermino', '')
                    setValue('horaTermino', '')
                    setValue('horaTermino', '')
                    setValue('status', 1)
                    setValue('tiposServicosId', filtrosAgenda?.tiposServicosId.toString())
                    setValue('profissionaisId', filtrosAgenda?.profissionaisId)

                    setTipoServicosAtend([filtrosAgenda?.tiposServicosId])

                    let diaSemanaW = new DayPilot.Date(args.start)
                    diaSemanaW = diaSemanaW.getDayOfWeek()




                     setNaoAtende('')
                    let verificaAtende = dadosProfissional?.profissional_agenda.find(item => (item.diasSemanasId - 1) == diaSemanaW)

                    // Verificar ao alterar o campo de horario
                    if (verificaAtende != undefined && verificaAtende?.status == 1) {
                        if (verificaAtende != undefined && verificaAtende?.status == 1) {

                            let dataCal = args.start.split('T')
                            let inicio = new DayPilot.Date(dataCal[0] + 'T' + verificaAtende.inicio)
                            let fim = new DayPilot.Date(dataCal[0] + 'T' + verificaAtende.termino)

                            let msgBloq = 'Este profissional não atende neste horário'
                            if (verificaAtende.status == 0) {
                                setNaoAtende(msgBloq);
                            }else
                            if (new DayPilot.Date(args.start) < inicio || new DayPilot.Date(args.start) > fim) {
                                setNaoAtende(msgBloq);
                            }
                        }
                    } 


                }


            }
        }




        setSelectedCliente([])
        setOptionsServicos([])
        setSelectedServico([])
        setOptionsAnimais([])
        setShowTermino(false)
    }, [args])


    //Clientes
    const handleSearchClientes = async (query) => {
        //  console.log(query)

        try {
            const data = await ClienteService.getAll(query)
            if (data.success) {
                setOptionsClientes(data.data)
            }
        } catch (error) {

        }
    }

    const handleChangeClientes = async (item) => {
        // console.log(item)
        if (item.length > 0) {
            setValue('clientesId', item[0].id)
            setSelectedCliente(item)


            if (item[0]?.animais != null) {

                setOptionsAnimais(item[0].animais)



            }


        } else {
            setValue('clientesId', null)
            setOptionsAnimais([])
            setSelectedCliente([])
        }
    }

    //Serviços
    const handleSearchServicos = async (query) => {
        const tiposServicosId = tipoServicosAtend
        let filtros = {
            agendavel: 1
        }
    console.log(tipoServicosAtend)
        try {
            const data = await ServicosService.getAll(query, tiposServicosId, filtros)
            if (data.success) {
                setOptionsServicos(data.data)
            }
        } catch (error) {

        }
    }

    const handleChangeServicos = (item) => {
        if (item.length > 0) {
            setValue('servicosId', item[0].id)
            setValue('tiposServicosId', item[0]?.tipos_servicos.id.toString())
            setValue('servicosQnt', 1)
            setSelectedServico(item)
            if (item[0]?.precoVariavel == 1) {
                setValue('servicosValor', item[0]?.valor)
            }
        } else {
            setValue('servicosId', null)
            setValue('servicosQnt', 1)
            setSelectedServico([])
        }

    }

    const calcTotalServico = () => {


        if (selectedservico.length > 0) {
            let valor = (selectedservico[0]?.precoVariavel == 1) ? getValues('servicosValor') : selectedservico[0].valor
            let qnt = getValues('servicosQnt')
            setValorTotal(valor * qnt)
        }
    }

    const handleSetDiaria = () => {
        if (txtDiaria != '') {
            let days = calculaDiasPernoite()

            setValue('servicosQnt', days)
            setTxtDiaria('')
        }
    }

    useEffect(() => {
        //    console.log(watchTipoAgendamento)


        setExibeTipoAg(watchTipoAgendamento)

    }, [watchTipoAgendamento])
    useEffect(() => {
        calcTotalServico()
    }, [selectedservico, watchQntServicos])

    useEffect(() => {
        if (getValues('dataTermino') != '' && selectedservico.length > 0 && selectedservico[0]?.pernoite == 1) {
            calculaDiasPernoite()
        }

    }, [watchDtInicio, watchDtTermino])

    useEffect(() => {

        calcTotalServico()
    }, [watchservicosValor])

    useEffect(() => {
        //  console.log(optionsAnimais)
        if (optionsAnimais.length == 1) {
            setValue('animaisId', optionsAnimais[0].id)
        }
    }, [optionsAnimais])

    const handleChangeCheckTermino = (e) => {
        setShowTermino(e.target.checked);
        if (!e.target.checked) {
            setValue('dataTermino', '')
            setTxtDiaria('')
        }
    }



    const onSubmit = async (dados) => {
        let { servicosId, tiposServicosId, dataTermino, horaTermino, dataInicio, horaInicio,
            ...formData } = dados

        formData.clientesId = (dados?.clientesId != 'undefined' && dados?.clientesId != '') ? dados?.clientesId : null
        formData.animaisId = (dados?.animaisId != 'undefined' && dados?.animaisId != '') ? dados?.animaisId : null
        // return false;
        if (dados?.tiposServicosId != undefined) {
            formData.tiposServicosId = dados.tiposServicosId.toString()
        }
        if (dados?.servicosId != undefined) {
            formData.servicosId = [dados.servicosId]
        }
        if (dados?.servicosQnt != undefined) {
            formData.servicosQnt = [dados.servicosQnt]
        }
        if (dados?.servicosValor != undefined) {
            formData.servicosValor = [dados.servicosValor]
        }
        if (dados?.servicosAgendaItemId != undefined) {
            formData.servicosAgendaItemId = [dados.servicosAgendaItemId]
        }
        if (dados?.servicosAgendaItemId != undefined) {
            formData.servicosAgendaItemId = [dados.servicosAgendaItemId]
        }

        if (dados?.dataTermino != undefined && dados?.dataTermino != null && dados?.dataTermino != '') {
            formData.termino = dataTermino + ' ' + horaTermino.substring(0, 5) + ':00'
        }

        formData.inicio = dados.dataInicio + ' ' + dados.horaInicio.substring(0, 5) + ':00'


        if (idAgendamento == null) {
            const submit = await AgendamentosService.store(formData)

            if (submit.success) {
                refreshAgendamentos()
                handleClose()
            }


        } else {
            const submit = await AgendamentosService.update(idAgendamento, formData)
            if (submit.success) {
                refreshAgendamentos()
                handleClose()
            }
        }




    }
    //  console.log(errors)
    //console.log(watchTipoAgendamento)

    return (

        <Modal show={show} onHide={() => handleClose()} size='lg'>
            <Modal.Body style={{ fontSize: '14px' }}>
                <h4 className="text-primary text-center">Agendar  </h4>


                {(
                    (!listPermissoes?.cadastrar && args?.id == null)
                    || (!listPermissoes?.editar && args?.id != null)
                ) ? (<PermissoesComponent showMsg={true}>
                    <Modal.Footer className='justify-content-center'>
                        <Button variant='danger' size='sm' onClick={() => handleClose()}><FontAwesomeIcon icon={faCircleXmark} /> Fechar</Button>
                    </Modal.Footer>
                </PermissoesComponent>) : (
                    <>
                        {(naoAtende == '') ? (

                            <Form>

                                <Row>
                                    <Form.Group as={Col} sm={6} >
                                        <Form.Label>Tipo de agendamento:</Form.Label>
                                        <Form.Select
                                            {...register('tipoAgendamentoId')}
                                        >
                                            <option value="1">Agendamento</option>
                                            <option value="2">Anotações</option>
                                            <option value="3">Bloqueio</option>
                                        </Form.Select>

                                    </Form.Group>
                                </Row>
                                <hr className='hr-15'></hr>


                                {exibeTipoAg == 1 && (
                                    <>
                                        <Row>

                                            <FormGroup as={Col} sm={6} controlId='clienteId'>
                                                <Form.Label>Cliente:</Form.Label>
                                                <div style={{ display: (selectedCliente.length > 0) ? '' : 'none' }}>
                                                    <div>
                                                        {(selectedCliente.length > 0) ? selectedCliente[0].nome : ''}

                                                        <a href="#" onClick={() => handleChangeClientes([])} style={{ display: (idAgendamento == null) ? '' : 'none' }}> Alterar</a>
                                                    </div>

                                                </div>

                                                <div style={{ display: (selectedCliente.length == 0) ? '' : 'none' }}>

                                                    <AsyncTypeahead
                                                        isInvalid={!!(errors?.clientesId)}
                                                        clearButton
                                                        filterBy={() => true}
                                                        id='clientesId'
                                                        labelKey={'nome'}
                                                        minLength={3}
                                                        onSearch={handleSearchClientes}
                                                        selected={selectedCliente}
                                                        onChange={handleChangeClientes}
                                                        options={optionsClientes}
                                                        placeholder='Digite o nome do Cliente ou Animal'
                                                        renderMenuItemChildren={(option) => (
                                                            <>
                                                                {option.nome}   - {option.cpf}
                                                            </>
                                                        )}
                                                    >
                                                    </AsyncTypeahead>
                                                    <Form.Control.Feedback type='invalid' >
                                                        {errors?.clientesId?.message}
                                                    </Form.Control.Feedback>
                                                </div>
                                            </FormGroup>

                                            <FormGroup as={Col} sm={6} controlId='animaisId'>
                                                <Form.Label>Animal:</Form.Label>
                                                <Form.Select

                                                    {...register('animaisId')}
                                                    isInvalid={!!(errors?.animaisId)}
                                                >
                                                    <option value="">Selecione</option>
                                                    {optionsAnimais.map((item) => (
                                                        <option value={item.id}>{item.nome}</option>
                                                    )
                                                    )}


                                                </Form.Select>
                                                <Form.Control.Feedback type='invalid' >
                                                    {errors?.animaisId?.message}
                                                </Form.Control.Feedback>

                                            </FormGroup>
                                        </Row>
                                        <Row>
                                            { /* <FormGroup as={Col} controlId='tiposServicosId'>
                            <Form.Label>Tipo do serviço:</Form.Label>
                            <Form.Select
                                size='sm'
                                {...register('tiposServicosId')}
                                isInvalid={!!(errors?.tiposServicosId)}
                            >
                                <option value=''>Selecione...</option>
                                {tiposServicosUtils().map((item) => (
                                    <option value={item.id}>{item.nome} </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type='invalid' />

                        </FormGroup>
                        */}
                                            <FormGroup as={Col} controlId='servicosId'>
                                                <Form.Label>Serviço:</Form.Label>
                                                <div style={{ display: (selectedservico.length > 0) ? '' : 'none' }}>
                                                    <div>
                                                        <table className='table'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Nome</th>
                                                                    <th>Qnt.</th>
                                                                    <th>Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td> {selectedservico[0]?.nome}  | {selectedservico[0]?.tipos_servicos?.nome}
                                                                        <a href="#" onClick={() => handleChangeServicos([])} className='ml-15'> Alterar</a>
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            size='sm'
                                                                            style={{ maxWidth: '100px' }}
                                                                            type='number'
                                                                            {...register('servicosQnt')}
                                                                            minLength={1}
                                                                            min={1}
                                                                        />

                                                                    </td>
                                                                    <td>
                                                                        {(selectedservico[0]?.precoVariavel == 1) ? (
                                                                            <>
                                                                                <Controller
                                                                                    name="servicosValor"
                                                                                    control={control}
                                                                                    render={({ field: { ref, ...rest } }) => (
                                                                                        <NumericFormat
                                                                                            className="form-control"
                                                                                            decimalSeparator=","
                                                                                            prefix=""
                                                                                            decimalScale={2}
                                                                                            getInputRef={ref}
                                                                                            {...rest}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </>
                                                                        )
                                                                            : <>
                                                                                R$ {float2moeda(selectedservico[0]?.valor)}
                                                                            </>}

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div style={{ display: (selectedservico.length > 0) ? '' : 'none' }}>

                                                            <div className='text-right'><label>Total: R$ {float2moeda(valorTotal)}</label>  </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div style={{ display: (selectedservico.length == 0) ? '' : 'none' }}>
                                                    <AsyncTypeahead
                                                        size='sm'
                                                        clearButton
                                                        filterBy={() => true}
                                                        id='servicosId'
                                                        labelKey={'nome'}
                                                        minLength={0}
                                                        onSearch={handleSearchServicos}
                                                        selected={selectedservico}
                                                        onChange={handleChangeServicos}
                                                        options={optionsServicos}
                                                        placeholder='Digite o serviço'
                                                        renderMenuItemChildren={(option) => (
                                                            <>
                                                                {option.nome}   - R$ {float2moeda(option.valor)} | {option.tipos_servicos?.nome}
                                                            </>
                                                        )}
                                                    />
                                                </div>
                                                <Form.Control.Feedback type='invalid' />

                                            </FormGroup>

                                        </Row>
                                        <hr></hr>

                                    </>
                                )}


                                <Row>
                                    <FormGroup as={Col} md={6} sm={6} lg={3} controlId='dataInicio'>
                                        <Form.Label>Data de início</Form.Label>
                                        <Form.Control type='date'
                                            {...register('dataInicio')}
                                        />
                                    </FormGroup>
                                    <FormGroup as={Col} md={6} sm={6} lg={3} controlId='horaInicio' >
                                        <Form.Label>Hora de início</Form.Label>
                                        <Form.Control type='time'
                                            {...register('horaInicio')}
                                        />
                                        <FormCheck inline label='Definir término?' style={{ color: '#ccc' }} onChange={handleChangeCheckTermino} />
                                    </FormGroup>


                                    <FormGroup as={Col} md={6} sm={6} lg={3} controlId='dataTermino' style={{ display: (showTermino) ? '' : 'none' }}>
                                        <Form.Label>Data de término</Form.Label>
                                        <Form.Control type='date'
                                            {...register('dataTermino')}
                                        />
                                        <span style={{ cursor: 'pointer' }} title='Clique aqui para alterar a quantidade do serviço.' className='text-success' onClick={() => handleSetDiaria()}>{txtDiaria}</span>
                                    </FormGroup>

                                    <FormGroup as={Col} md={6} sm={6} lg={3} controlId='horaTermino' style={{ display: (showTermino) ? '' : 'none' }}>
                                        <Form.Label>Hora de término</Form.Label>
                                        <Form.Control type='time'
                                            {...register('horaTermino')}
                                        />
                                    </FormGroup>
                                </Row>

                                <Row className='mt-10'>

                                    {exibeTipoAg == 1 && (
                                        <>
                                            <FormGroup as={Col} sm={6} md={4} controlId='status'>
                                                <Form.Label>Status do Agendamento:</Form.Label>
                                                <Form.Select as={'textarea'}
                                                    {...register('status')}
                                                    size='sm'
                                                >
                                                    {statusAgendamentosUtils().map((item) => (
                                                        <option value={item.id}>{item.nome}</option>
                                                    )
                                                    )}

                                                </Form.Select>
                                            </FormGroup>
                                        </>)}

                                    <FormGroup as={Col} sm={6} md={8} controlId='observacoes' >
                                        <Form.Label>Observações:</Form.Label>
                                        <Form.Control as={'textarea'}
                                            {...register('observacoes')}
                                            size='sm'
                                        ></Form.Control>
                                    </FormGroup>
                                </Row>


                                <Modal.Footer className='justify-content-center'>
                                    <Button variant='danger' size='xs' onClick={() => handleClose()}>Fechar</Button>
                                    <Button variant='primary' size='xs' onClick={() => handleSubmit(onSubmit)()}>Salvar</Button>
                                </Modal.Footer>
                            </Form>

                        ) : <div className='alert alert-danger'>{naoAtende}</div>}

                    </>)}
            </Modal.Body>

        </Modal>
    )
}


export default AgendaCadModal;